import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=8bd98dbe&scoped=true"
import script from "./form2.vue?vue&type=script&lang=js"
export * from "./form2.vue?vue&type=script&lang=js"
import style0 from "./form2.vue?vue&type=style&index=0&id=8bd98dbe&prod&lang=scss&scoped=true"
import style1 from "./form2.vue?vue&type=style&index=1&id=8bd98dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd98dbe",
  null
  
)

export default component.exports